import {TBody} from "./TBody";

export const Table = {
    TBody
}
